module.exports = __webpack_public_path__ + "img/pr-13.eb5add64.png";